import GooglePayButton from '@google-pay/button-react';
import clsx from 'clsx';
import { useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';

import { DeviceTypes } from 'constants/app';
import { FORM_KEY } from 'constants/form-ids';
import { GOOGLE_PAY_MERCHANT_ID, GOOGLE_PAY_MERCHANT_NAME } from 'constants/google-pay';
import { useAmount, usePayment } from 'hooks';
import { useAppSelector } from 'store/hooks';
import { useGetCertQuery } from 'store/payment/service';
import { detectDeviceType } from 'utils';

import { CVVModal } from './cvv-modal';

const isDev = process.env.REACT_APP_NODE_ENV === 'development' ? 'TEST' : 'PRODUCTION';

const GooglePay = ({ acquiringID }: { acquiringID: number }) => {
  const { data: cert } = useGetCertQuery(null);
  const methods = useForm({
    mode: 'onChange',
    defaultValues: {
      cvv: '',
    },
  });
  const { formKey, paymentData } = useAppSelector((state) => state.payment);
  const [isOpen, setIsOpen] = useState(false);
  const [googlePaymenData] = useState<google.payments.api.PaymentData>();
  const { fetchSendPayment } = usePayment();
  const { currentAmount, currentAmountForPayment } = useAmount();

  const handleGooglePayment = async (data: any) => {
    if (data && cert) {
      const payData = {
        ID: paymentData?.ID,
        acquiringID,
        amount: currentAmountForPayment,
        googleToken: data?.paymentMethodData.tokenizationData.token,
      };

      await fetchSendPayment(payData);
    }
  };

  return detectDeviceType() === DeviceTypes.ANDROID || detectDeviceType() === DeviceTypes.OTHER ? (
    <FormProvider {...methods}>
      {googlePaymenData && (
        <CVVModal
          close={() => setIsOpen(false)}
          isOpen={isOpen}
          payment={handleGooglePayment}
          googlePaymentData={googlePaymenData}
        />
      )}

      <GooglePayButton
        environment={isDev}
        buttonColor="black"
        buttonLocale="ru"
        buttonType="short"
        buttonSizeMode="fill"
        className={clsx(
          'base-gpay',
          formKey === FORM_KEY.SZ && 'sz-gpay',
          formKey === FORM_KEY.XBET && 'xbet-gpay',
          formKey === FORM_KEY.BET_CITY && 'xbet-gpay',
          formKey === FORM_KEY.FONBET && 'fonbet-gpay',
        )}
        paymentRequest={{
          apiVersion: 2,
          apiVersionMinor: 0,
          allowedPaymentMethods: [
            {
              type: 'CARD',
              parameters: {
                allowedAuthMethods: ['PAN_ONLY', 'CRYPTOGRAM_3DS'],
                allowedCardNetworks: ['MASTERCARD', 'VISA'],
              },
              tokenizationSpecification: {
                type: 'PAYMENT_GATEWAY',
                parameters: {
                  gateway: 'kassa24pay',
                  gatewayMerchantId: GOOGLE_PAY_MERCHANT_ID,
                },
              },
            },
          ],
          merchantInfo: {
            merchantId: GOOGLE_PAY_MERCHANT_ID,
            merchantName: GOOGLE_PAY_MERCHANT_NAME,
          },
          transactionInfo: {
            totalPriceStatus: 'FINAL',
            currencyCode: 'KZT',
            totalPrice: currentAmount,
          },
        }}
        onLoadPaymentData={(paymentRequest) => {
          handleGooglePayment(paymentRequest);
        }}
      />
    </FormProvider>
  ) : null;
};

export { GooglePay };
